/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Project_LabelInputs */

const en_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

const fr_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

const de_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt`)
};

const it_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto`)
};

const ru_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект`)
};

const es_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto`)
};

const zh_cn2_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目`)
};

const ja_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト`)
};

const hi_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना`)
};

const pt_pt2_file_import_project_label = /** @type {(inputs: File_Import_Project_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto`)
};

/**
* | output |
* | --- |
* | "Project" |
*
* @param {File_Import_Project_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_project_label = /** @type {((inputs?: File_Import_Project_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Project_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_project_label(inputs)
	if (locale === "de") return de_file_import_project_label(inputs)
	if (locale === "it") return it_file_import_project_label(inputs)
	if (locale === "ru") return ru_file_import_project_label(inputs)
	if (locale === "es") return es_file_import_project_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_project_label(inputs)
	if (locale === "ja") return ja_file_import_project_label(inputs)
	if (locale === "hi") return hi_file_import_project_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_project_label(inputs)
	return en_file_import_project_label(inputs)
});